// extracted by mini-css-extract-plugin
export default {"carousel":"Flags-carousel_A6M2O","flag":"Flags-flag_BECJg","active":"Flags-active_v5EWw","exiting":"Flags-exiting_Meb2j"};